const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSealadd16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(16,2)",
    d: "m168-2c-1.1153-1e-7 -1.4598 1.5615-2.4902 1.9883-1.0304 0.4268-2.3774-0.43316-3.166 0.35547-0.78863 0.78862 0.0713 2.1356-0.35547 3.166-0.4268 1.0304-1.9883 1.375-1.9883 2.4902 0 1.1153 1.5615 1.4598 1.9883 2.4902s-0.43316 2.3774 0.35547 3.166c0.78862 0.78862 2.1356-0.07133 3.166 0.35547 1.0304 0.4268 1.375 1.9883 2.4902 1.9883 0.91816 0 1.3139-1.0577 2-1.6699v-0.33008h-2c-0.55226-5.5e-5 -0.99994-0.44774-1-1v-2c6e-5 -0.55226 0.44774-0.99994 1-1h2v-2c6e-5 -0.55226 0.44774-0.99994 1-1h2c0.55226 5.52e-5 0.99994 0.44774 1 1v2h0.33008c0.61222-0.68612 1.6699-1.0818 1.6699-2 0-1.1153-1.5615-1.4598-1.9883-2.4902s0.43316-2.3774-0.35547-3.166c-0.78862-0.78863-2.1356 0.071332-3.166-0.35547-1.0304-0.4268-1.375-1.9883-2.4902-1.9883z",
    fill: "#ff8080",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184 3c-2.7496 0-5 2.2504-5 5 0 2.4072 1.7254 4.4316 4 4.8984v-1.0371a4 4 0 0 1-3-3.8613 4 4 0 0 1 4-4 4 4 0 0 1 3.8711 3h1.0274c-0.46688-2.2746-2.4912-4-4.8984-4z",
    color: "#000000",
    fill: "#fff",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187 8v3h-3v2h3v3h2v-3h3v-2h-3v-3z",
    color: "#000000",
    fill: "#2c5aa0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealadd16);
export default __webpack_public_path__ + "static/media/seal.add.16.3250c8d12f7ab74ec782d038a60d9155.svg";
export { ForwardRef as ReactComponent };